<div class="vc-admin-customers vc-view-shell">
  <main class="vc-admin-customers__layout vc-view-content">
    <section class="vc-admin-customers__frame vc-surface-panel">
      <header class="vc-admin-customers__header">
        <h2>{{ "ADMIN.CUSTOMERS.TITLE" | translate }}</h2>
        <p>{{ "ADMIN.WORKSPACE.NAV.CUSTOMERS" | translate }}</p>
      </header>

      <nav class="vc-admin-customers__tabs">
        @for (tab of items; track tab.routerLink) {
          <a
            [routerLink]="tab.routerLink"
            routerLinkActive="vc-admin-customers__tab--active"
            class="vc-admin-customers__tab"
          >
            <i [class]="tab.icon"></i>
            <span>{{ tab.labelKey | translate }}</span>
          </a>
        }
      </nav>

      <div class="vc-admin-customers__content vc-admin-content-scope">
        <router-outlet></router-outlet>
      </div>
    </section>
  </main>
</div>
